module.exports = __webpack_public_path__ + "static/media/7.d0ccd2b1.jpg";